import $ from "jquery";

import quilterFunctions from "../helpers/quilter-functions";
import utils from "../helpers/utils";

// Header of the site including tophat, nav, hero etc, is displayed as a grid for positioning
// This gets broken when js-header gets removed from the flow by position fixed
// To resolve we create here a ghost div to take its place (until we implement a better solution in CSS)

function init(): void {
  const stickyClass = "sticky";
  const reorientEvent = "resize orientationchange";
  const $window = $(window);
  const $header = $(".js-header");
  const $headerHamburger = $(".header__hamburger");
  const $headerLogo = $(".header__logo");

  const closeModals = () =>
    {
      quilterFunctions.closeModal(".dialog");
    };

  const unstickMobileHeaderElements = () => {
    $headerLogo.removeClass(stickyClass);
    $headerHamburger.removeClass(stickyClass);
  }

  const stickHeaderLogoAndCloseMenuButton = () =>
    {
      const top = $header.scrollTop();
      if (!utils.isMobile()) return;

      if (top > 0) {
        $headerLogo.addClass(stickyClass);
        $headerHamburger.addClass(stickyClass);
      } else {
        unstickMobileHeaderElements();
      }
    };

  const updatePosition = () =>
    {
      const top = $window.scrollTop();
      const headerH = $header.outerHeight();
      const $fakeHeader = $(".header--fake");
      $header.removeClass(stickyClass); // unstick so offset() is measurable
      closeModals();

      if (!$headerHamburger.hasClass("nav-open")) {
        unstickMobileHeaderElements();
      }

      if (top > $header.offset().top) {
        $header.addClass(stickyClass);
        if (!$fakeHeader.length) {
          const el = document.createElement("div");
          el.setAttribute("style", `height: ${headerH}px;`);
          el.className = "header header--fake";
          $(".top-hat-and-nav-wrapper").append(el);
        }
      } else {
        $header.removeClass(stickyClass);
        if ($fakeHeader.length) {
          $fakeHeader.remove();
        }
      }

      stickHeaderLogoAndCloseMenuButton();
    };

  $header.on("scroll", updatePosition);

  window.addEventListener('mobile-nav-toggled', () => {
    updatePosition();
  })

  if ($header.length) {
    $window.on("load scroll", updatePosition);

    $window.on(reorientEvent, () =>
    {
      setTimeout(() =>
      {
        updatePosition();
      }, 0);
    });
  }
}

export default { init };
